<div class="modal-header upgrade-hero relative gap-3 shrink-0">
    <div class="relative z-10 flex min-w-0 items-center gap-3">
        <div class="upgrade-emblem rounded-box flex size-12 shrink-0 items-center justify-center" aria-hidden="true">
            <app-icon icon="ph:arrow-circle-up" size="lg" />
        </div>
        <h2 class="modal-title text-xl sm:text-2xl" id="upgrade-modal-title">{{ getTranslationPrefix() + '.title' | translate }}</h2>
    </div>
    <button type="button" class="btn btn-sm btn-circle btn-ghost relative z-10 shrink-0"
            [attr.aria-label]="'common.buttons.close' | translate" [disabled]="processing" (click)="close()">
        <app-icon icon="app:close" size="md" />
    </button>
</div>

<div class="modal-body flex flex-col gap-5">
    <p class="text-muted" [innerHTML]="getTranslationPrefix() + '.description' | translate"></p>

    <ul class="flex flex-col gap-3">
        @for (feature of [1, 2, 3]; track feature) {
            <li class="flex items-start gap-3">
                <app-icon icon="app:check" size="md" class="shrink-0 opacity-40" aria-hidden="true" />
                <span class="text-sm" [innerHTML]="getTranslationPrefix() + '.feature.' + feature | translate"></span>
            </li>
        }
    </ul>

    @if (planOffers.length) {
        <div class="card-inset -mx-4 -mb-4 p-4 flex flex-col gap-3">
            <div class="flex flex-col sm:flex-row gap-3">
                @for (offer of planOffers; track offer.plan) {
                    <div class="flex flex-1 min-w-0 flex-col gap-2 rounded-box p-3"
                         [class.upgrade-plan-recommended]="offer.plan === 'advanced'">
                        <div class="flex flex-wrap items-center justify-between gap-2">
                            <span class="font-semibold">{{ 'guideglare.subscription.plan.' + offer.plan | translate }}</span>
                            @if (offer.plan === 'advanced') {
                                <span class="badge badge-xs badge-ghost">{{ 'subscription.plan.recommended' | translate }}</span>
                            }
                        </div>
                        <p class="text-sm sm:min-h-10">{{ 'upgrade.modal.zero.100.feature.' + (offer.plan === 'basic' ? 1 : 2) | translate: {
                            multiple: offer.freeLimitMultiple
                        } }}</p>
                        @if (offer.pricing.hasDiscount) {
                            <span class="line-through opacity-60 num text-sm">{{ offer.pricing.formattedOriginalPrice }}</span>
                        }
                        <div class="flex flex-wrap items-baseline gap-x-2 gap-y-1">
                            <span class="text-2xl font-semibold num">
                                {{ offer.pricing.hasDiscount ? offer.pricing.formattedDiscountedPrice : offer.pricing.formattedOriginalPrice }}
                            </span>
                            <span class="text-muted">
                                {{ (offer.pricing.presentation?.unitKey ?? 'subscription.price.per.month') | translate }}
                            </span>
                        </div>
                        @if (offer.pricing.hasDiscount) {
                            <span class="text-xs flex items-center gap-1">
                                <app-icon icon="ph:gift" size="sm" class="opacity-40" aria-hidden="true" />
                                {{ discountBadgeKey | translate: { discount: getDiscountValue() } }}
                            </span>
                            @if (offer.pricing.presentation?.noteKey; as noteKey) {
                                <p class="text-hint">
                                    {{ noteKey | translate: { price: offer.pricing.formattedOriginalPrice, months: offer.pricing.presentation?.months } }}
                                </p>
                            }
                        }
                    </div>
                }
            </div>
            @if (priceDifference; as difference) {
                <p class="text-sm">{{ 'upgrade.modal.zero.100.feature.3' | translate: {
                    priceDifference: difference, multiple: advancedLimitMultiple
                } }}</p>
            }
        </div>
    }
</div>

<div class="modal-footer shrink-0 flex-col-reverse sm:flex-row sm:flex-nowrap">
    <button type="button" class="btn btn-ghost w-full sm:w-auto h-auto min-h-12 whitespace-normal"
            [disabled]="processing" (click)="close()">
        {{ getTranslationPrefix() + '.later' | translate }}
    </button>
    <button type="button" class="btn btn-primary w-full sm:w-auto min-w-0 h-auto min-h-12 whitespace-normal"
            [disabled]="processing" [attr.aria-busy]="processing" (click)="navigateToSubscription()">
        @if (processing) {
            <span class="loading loading-spinner loading-sm" aria-hidden="true"></span>
        }
        <span>{{ getButtonTranslationKey() | translate }}</span>
    </button>
</div>
